import * as React from 'react';
import { colors } from '../../../index';

const IconCrossCircle = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.096 1.904A6.454 6.454 0 006.5 0a6.454 6.454 0 00-4.596 1.904A6.454 6.454 0 000 6.5c0 1.737.676 3.368 1.904 4.596A6.454 6.454 0 006.5 13a6.454 6.454 0 004.596-1.904A6.454 6.454 0 0013 6.5a6.454 6.454 0 00-1.904-4.596zm-.523 8.67A5.724 5.724 0 016.5 12.26a5.722 5.722 0 01-4.073-1.688 5.767 5.767 0 010-8.146A5.724 5.724 0 016.5.739c1.537 0 2.985.599 4.073 1.688a5.767 5.767 0 010 8.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.283 3.717a.358.358 0 00-.508 0L6.5 5.992 4.225 3.717a.358.358 0 00-.508 0 .358.358 0 000 .507L5.992 6.5 3.717 8.775a.361.361 0 00.253.614.35.35 0 00.252-.106l2.275-2.276 2.276 2.276a.36.36 0 00.252.106.346.346 0 00.253-.106.358.358 0 000-.508L7.008 6.5l2.275-2.276a.358.358 0 000-.507z"
  })));
};

export default IconCrossCircle;